// eslint-disable-next-line import/no-unresolved
module.exports = require('./build/OutsideClickHandler');



//////////////////
// WEBPACK FOOTER
// ./~/react-outside-click-handler/index.js
// module id = 380
// module chunks = 0